export const enum DashboardActionTypes {
  // TODO : Change below, as currently just kept placeholder

  FETCH_DASHBOARD_DATA = 'FETCH_DASHBOARD_DATA',
  GLOBAL_SET_LANGUAGE = 'GLOBAL_SET_LANGUAGE',
}

export const enum FlashMessageActionTypes {
  SHOW_FLASH_MESSAGE = 'SHOW_FLASH_MESSAGE'
}

export const enum UserActionTypes {
  FETCH_USER_PROFILE_DATA = 'FETCH_USER_PROFILE_DATA',
}

export const enum BorrowerActionTypes {
  FETCH_BORROWER_PROFILE_DATA = 'FETCH_BORROWER_PROFILE_DATA',
}

export const enum RepaymentActionTypes {
  CREATE_REPAYMENT = 'CREATE_REPAYMENT',
  ERROR_CREATE_REPAYMENT = 'ERROR_CREATE_REPAYMENT',
  GET_CREATED_REPAYMENTS = 'GET_CREATED_REPAYMENTS',
  ERROR_GET_CREATED_REPAYMENTS = 'ERROR_GET_CREATED_REPAYMENTS',
  CONFIRM_REPAYMENT = 'CONFIRM_REPAYMENT',
  ERROR_CONFIRM_REPAYMENT = 'ERROR_CONFIRM_REPAYMENT',
  SET_REPAYMENT_INFORMATION = 'SET_REPAYMENT_INFORMATION',
  CLEAR_REPAYMENT_INFORMATION = 'CLEAR_REPAYMENT_INFORMATION',
  LOAD_REPAYMENT_INFORMATION = 'LOAD_REPAYMENT_INFORMATION',
  ERROR_SET_REPAYMENT_INFORMATION = 'ERROR_SET_REPAYMENT_INFORMATION',
}

export const enum SubmissionActionTypes {
  CREATE_NEW_LOAN_SUBMISSION = 'CREATE_NEW_LOAN_SUBMISSION',
  GET_SUBMISSIONS = 'GET_SUBMISSIONS',
  CANCEL_SUBMISSION = 'CANCEL_SUBMISSION',
  ERROR_CREATE_NEW_LOAN_SUBMISSION = 'ERROR_CREATE_NEW_LOAN_SUBMISSION',
  ERROR_GET_SUBMISSIONS = 'ERROR_GET_SUBMISSIONS',
  ERROR_CANCEL_SUBMISSION = 'ERROR_CANCEL_SUBMISSION',
  REFRESH_SUBMISSIONS = 'REFRESH_SUBMISSIONS',
  STORE_TRANSACTIONS = 'STORE_TRANSACTIONS',
  CLEAR_SUBMISSIONS_V2_PAYLOAD = 'CLEAR_SUBMISSIONS_V2_PAYLOAD',
}

export const enum LoanApplicationActionTypes {
  GET_LOAN_APPLICATIONS = 'GET_LOAN_APPLICATIONS',
  ERROR_GET_LOAN_APPLICATIONS = 'ERROR_GET_LOAN_APPLICATIONS',
  UPDATE_LOAN_APPLICATION = 'UPDATE_LOAN_APPLICATION',
  UPDATE_LOAN_APPLICATION_INPROGRESS = 'UPDATE_LOAN_APPLICATION_INPROGRESS',
  ERROR_UPDATE_LOAN_APPLICATION = 'ERROR_UPDATE_LOAN_APPLICATION',
  GET_LOAN_APPLICATION_CONTRACT = 'GET_LOAN_APPLICATION_CONTRACT',
  GET_LOAN_APPLICATION_CONTRACT_INPROGESS = 'GET_LOAN_APPLICATION_CONTRACT_INPROGESS',
  GET_LOAN_APPLICATION_CONTRACT_COMPLETED = 'GET_LOAN_APPLICATION_CONTRACT_COMPLETED',
  ERROR_GET_LOAN_APPLICATION_CONTRACT = 'ERROR_GET_LOAN_APPLICATION_CONTRACT',
}

export const enum LoanActionTypes {
  GET_LOAN_DATA = 'GET_LOAN_DATA',
  ERROR_GET_LOAN_DATA = 'ERROR_GET_LOAN_DATA',
}

export const enum DisbursementPayoutActionTypes {
  CREATE_LOAN_APPLICATION_DISBURSEMENT_PAYOUT = 'CREATE_LOAN_APPLICATION_DISBURSEMENT_PAYOUT',
  ERROR_LOAN_APPLICATION_DISBURSEMENT_PAYOUT = 'ERROR_LOAN_APPLICATION_DISBURSEMENT_PAYOUT',
  RESET_LOAN_APPLICATION_DISBURSEMENT_PAYOUT = 'RESET_LOAN_APPLICATION_DISBURSEMENT_PAYOUT'
}

export const enum BeneficiaryActionTypes {
  GET_BENEFICIARY_DATA = 'GET_BENEFICIARY_DATA',
  ERROR_GET_BENEFICIARY_DATA = 'ERROR_GET_BENEFICIARY_DATA',
}

export const enum PaymentPlanActionTypes {
  GET_PAYMENT_PLAN_DATA = 'GET_PAYMENT_PLAN_DATA',
  ERROR_GET_PAYMENT_PLAN_DATA = 'ERROR_GET_PAYMENT_PLAN_DATA',
}
